// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPortfolioModelMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PORTFOLIO_MODEL_MESSAGE);
        this.ModelID = null; // PFixIntField FIELD_PORTFOLIO_MODEL_ID = new PFixIntField(728); - идентификатор модели
        this.PortfolioSystemID = null; // PFixIntField FIELD_PORTFOLIO_SYSTEM_ID = new PFixIntField(727); - идентификатор портфолио системы, которой принадлежит модель
        this.ModelName = null; // PFixStringField FIELD_NAME = new PFixStringField(22); - имя модели
        this.Description = null; // PFixStringField FIELD_DESCRIPTION = new PFixStringField(28); - описание модели
        this.DiagramPercent = null; // PFixDoubleField FIELD_PERCENT = new PFixDoubleField(729); - Cash. Здесь указывается доля средств, которая будет оставаться на балансе пользователя. Используем для отображения доли Cash на карточке
        this.ByInstrumentPercent = {}; // группа с распределениями по инструмент ID
    }
}
